import { Avatar, Box, Button, Card, CardContent, Chip, Divider, Grid, Stack, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../features/auth/store';
import { ROLE_LABELS } from '../../../shared/constants';
import { initials, roleColor } from '../../../shared/utils';
import PageHeader from '../../../shared/PageHeader';

export default function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  if (!user) return null;

  return (
    <Box>
      <PageHeader title="Profile" subtitle="Your account details." action={
        <Button variant="outlined" startIcon={<Lock />} onClick={() => navigate('/portal/change-password')}>Change password</Button>
      } />
      <Card>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
              <Avatar sx={{ width: 120, height: 120, bgcolor: roleColor(user.role), fontSize: 40, fontWeight: 800, mx: 'auto' }}>
                {initials(user.fullName)}
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>{user.fullName}</Typography>
              <Chip label={ROLE_LABELS[user.role]} sx={{ mt: 1, bgcolor: roleColor(user.role), color: '#fff' }} />
            </Grid>
            <Grid item xs={12} md={8}>
              <Stack spacing={2}>
                <Field label="Username / Roll Number" value={user.username} />
                <Divider />
                <Field label="Email" value={user.email ?? '—'} />
                <Divider />
                {user.rollNumber && <><Field label="Roll Number" value={user.rollNumber} /><Divider /></>}
                {user.employeeId && <><Field label="Employee ID" value={user.employeeId} /><Divider /></>}
                <Field label="Role" value={ROLE_LABELS[user.role]} />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography color="text.secondary">{label}</Typography>
      <Typography sx={{ fontWeight: 600 }}>{value}</Typography>
    </Stack>
  );
}
